import { ReactNode } from "react";
import { Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";

/**
 * CTC version of the portal's info card (routes/customers/CustomInfoCard): same look, but rows keep
 * the value on the right while a long label wraps (up to two lines), and text is shown as written
 * (no capitalising of emails, references, file names). Empty values show "—".
 */
export interface CtcInfoRow {
    label: ReactNode;
    /** Smaller second line under the label, e.g. a file name. */
    sublabel?: ReactNode;
    value?: ReactNode;
}

export function CtcInfoCard({ title, icon, color, rows }: { title: ReactNode; icon: ReactNode; color: string; rows: CtcInfoRow[] }) {
    return (
        <Paper shadow="xs" p="md">
            <Group gap="sm" mb="sm" wrap="nowrap">
                <ThemeIcon color={color} variant="light">{icon}</ThemeIcon>
                <Text>{title}</Text>
            </Group>
            <Stack gap={6}>
                {rows.map((row, i) => {
                    const empty = row.value === undefined || row.value === null || row.value === "";
                    return (
                        <Group key={i} justify="space-between" align="flex-start" wrap="nowrap" gap="md">
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <Text size="sm" c="dimmed" lineClamp={2} style={{ overflowWrap: "anywhere" }}>{row.label}</Text>
                                {row.sublabel && <Text size="xs" c="dimmed" lineClamp={2} style={{ overflowWrap: "anywhere", opacity: 0.8 }}>{row.sublabel}</Text>}
                            </div>
                            <div style={{ flexShrink: 0, maxWidth: "60%", textAlign: "right" }}>
                                {typeof row.value === "string" || typeof row.value === "number" || empty ?
                                    <Text size="sm" fw={500} style={{ overflowWrap: "anywhere" }}>{empty ? "—" : row.value}</Text> :
                                    row.value}
                            </div>
                        </Group>
                    );
                })}
            </Stack>
        </Paper>
    );
}
